import { call, put, takeEvery } from "redux-saga/effects";
import { registrationRequest, registrationSuccess, registrationFailure } from "../slice/signSlice";
import { registrationApi } from "../../api/apiService";
import { PayloadAction } from "@reduxjs/toolkit";

// Define the registration process as a generator function
export function* register(
    action: PayloadAction<{
      first_name: string;
      last_name: string;
      gender: string;
      age: string;
      specialty?: string;
      credentials?: string;
      country?: string;
      npi?: string;
      license?: string;
      license_state?: string;
    }>
  ): Generator<any, void, any> {
    try {
        // Call the registration API
        const response = yield call(registrationApi, action.payload);

        console.log("RESPONSE 👉", response);

        if (!response?.data) {
            throw new Error("Empty response");
        }

        const { access, refresh } = response.data?.Token || {};

        if (!access || !refresh) {
            throw new Error("Token missing in response");
        }

        // Extract access and refresh tokens from the response
        //const { access, refresh } = response.data.Token;
        const message = response.data.message;

        // Dispatch success action with tokens and message
        yield put(registrationSuccess({ accessToken: access, refreshToken: refresh, message }));
    } catch (error: any) {
        console.log("ERROR 👉", error);
    
        let message = "Something went wrong";
    
        if (error?.response?.data) {
            const data = error.response.data;
    
            if (typeof data === "object") {
                const firstKey = Object.keys(data)[0];
                const firstError = data[firstKey];
    
                message = Array.isArray(firstError)
                    ? firstError[0]
                    : firstError;
            }
        } else if (error?.message) {
            message = error.message;
        }
    
        yield put(registrationFailure(message));
    }
}

// Watch for the registration request action and handle it
export function* signSaga() {
    yield takeEvery(registrationRequest.type, register);
}
